// extracted by mini-css-extract-plugin
export var checkbox = "_2w-0";
export var circle = "_2w-3";
export var horizontalContainer = "_2w-7";
export var sm = "_2w-5";
export var switch0 = "_2w-2";
export var switchDisabled = "_2w-8";
export var switchEnabled = "_2w-1";
export var textSwitchContainer = "_2w-9";
export var textSwitchOption = "_2w-a";
export var textSwitchOptionSelected = "_2w-b";
export var verticalContainer = "_2w-6";
export var xs = "_2w-4";